export default __webpack_public_path__ + "static/media/plus-circle-filled.ebf56e31.svg";